import TasksTable from './TasksTable';

export default TasksTable;
